import { useMemo } from "react";
import { useChecklistData } from "@/react/components/CommunityOnboarding/NewChecklistComponents/CheckList/useCheckListData";
import { useChecklistStore } from "@/react/stores/useChecklistStore";
import { usePunditUserContext } from "../contexts";

export const useChecklist = () => {
  const checklistData = useChecklistData();
  const { onboardingFlags } = usePunditUserContext();
  const { setChecklist, setFocusedStepKey, setExpandedSections } =
    useChecklistStore();

  const { currentCommunityMember } = usePunditUserContext();

  const isChecklistAvailable = useMemo(() => {
    if (!currentCommunityMember || !currentCommunityMember.is_admin) {
      return false;
    }
    return !onboardingFlags?.getting_started_checklist_hidden;
  }, [onboardingFlags, currentCommunityMember]);

  useMemo(() => {
    setChecklist(checklistData.checklist || null);

    if (checklistData.checklist) {
      setFocusedStepKey(checklistData.initialFocusedStepKey || null);

      const initialExpandedSectionsRecord: Record<string, boolean> = {};
      checklistData.initialExpandedSections.forEach(sectionTitle => {
        initialExpandedSectionsRecord[sectionTitle] = true;
      });
      setExpandedSections(initialExpandedSectionsRecord);
    }
  }, [
    checklistData.checklist,
    checklistData.initialFocusedStepKey,
    checklistData.initialExpandedSections,
    setChecklist,
    setFocusedStepKey,
    setExpandedSections,
  ]);

  return {
    checklist: checklistData.checklist,
    isLoading: checklistData.isChecklistLoading,
    error: checklistData.errorFetchingChecklist,
    sectionsWithFocus: checklistData.sectionsWithFocus,
    totalSteps: checklistData.totalSteps,
    completedSteps: checklistData.completedSteps,
    progress: checklistData.progress,
    initialFocusedStepKey: checklistData.initialFocusedStepKey,
    initialExpandedSections: checklistData.initialExpandedSections,
    isComplete: checklistData.isComplete,
    isChecklistAvailable,
  };
};
